import React, { useCallback, useState } from 'react';
import './ApplyPressure.css';
import GeneralButton from '../regular/GeneralButton';
import { Globals } from '../../../misc/helpers';
import $ from 'jquery';

var isMouseDown = false;
var delayed = false;

const ApplyPressure = (obj: any) => {
	const [preassure, setPreassure] = useState(0);
	const [timer, setTimer] = useState(null);
	const [disabled, setDisabled] = useState(null);
	const [transitionTime, setTransitionTime] = useState(1);

	const mouseDownCallback = useCallback(() => {
		isMouseDown = true;

		if(Globals.skipAnimations) {
			setPreassure(100);
		} else {
			setTransitionTime(16);
			setPreassure(100);
			setTimer(setTimeout(() => {
				setTransitionTime(16);
				setPreassure(100);
			}, 16000));
		}

		obj.parameters.dispatch({
			type: 'playSequence',
			value: {
				sequenceName: 'ApplyPressure',
				skipAnimations: Globals.skipAnimations
			}
		});

		if (obj.parameters.onTapAndHold) {
			obj.parameters.onTapAndHold();
		}
		
	}, [preassure]);

	const mouseUpCallback = useCallback(() => {
		if(!isMouseDown) {
			setTransitionTime(0);
			return;
		}
		isMouseDown = false;

		var $pdPercent = $('#pdPercent');
		var $pdPercentParent = $pdPercent.parent();

		var percent = ($pdPercent.height() / $pdPercentParent.height()) * 100;
		
		if(percent > 99) {
			setDisabled(true);
	
			if (obj.parameters.onDone) {
				obj.parameters.onDone();
			}
		}
		else {
			if (obj.parameters.onReleased) {
				obj.parameters.onReleased();
			}

			delayed = true;
			setTimeout(() => {
				obj.parameters.dispatch({
					type: 'playSequence',
					value: {
						sequenceName: 'ApplyPressureEnd',
						skipAnimations: Globals.skipAnimations
					}
				});
			}, 3000)
		}

		setTimer((timer: any) => clearInterval(timer));
		setTransitionTime(1);
		setPreassure(0);

	}, [timer, preassure, disabled]);

	const onKeyPress = useCallback((e: any) => {
		if (e.which == 90) {
			mouseDownCallback();
		}
	}, [timer, preassure, disabled]);

	const onKeyUp = useCallback((e: any) => {
		if (e.which == 90) {
			mouseUpCallback();
		}
	}, [timer, preassure, disabled]);

	return (
		<div className={`modal-disable-select apply-pressure-container ${obj.parameters.disabled ? 'disabled-container' : ''}`}>
			<div className="ui-inner-container">
				<div className="apply-pressure-background">
					<div className="apply-pressure-block">
						<div id="pdPercent" className="applied-pressure-block" style={{ height: 'calc(' + preassure + '% + 4px)', transition: 'height ' + transitionTime + 's linear'  }}>
						</div>
					</div>
				</div>
				<GeneralButton
					text="Tap & Hold"
					noButton={true}
					isPressureDressing={true}
					onMouseDown={mouseDownCallback}
					onMouseUp={mouseUpCallback}
					onMouseOut={mouseUpCallback}
					onKeyUp={onKeyUp}
					onKeyPress={onKeyPress}
					disabled={disabled}
				/>
			</div>
		</div>
	);
};

export default ApplyPressure;
